{
  "name": "luminous",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "csspurifier": "node ./src/scripts/purifycss.js",
    "build": "ng build && npm run csspurifier",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "dev:ssr": "ng run luminous:serve-ssr",
    "serve:ssr:luminous": "node dist/luminous/server/server.mjs"
  },
  "private": true,
  "dependencies": {
    "@abacritt/angularx-social-login": "2.2.0",
    "@angular-slider/ngx-slider": "^17.0.2",
    "@angular/animations": "^17.3.0",
    "@angular/cdk": "~17.3.10",
    "@angular/common": "^17.3.0",
    "@angular/compiler": "^17.3.0",
    "@angular/core": "^17.3.0",
    "@angular/forms": "^17.3.0",
    "@angular/material": "^17.3.10",
    "@angular/material-moment-adapter": "^17.3.10",
    "@angular/platform-browser": "^17.3.0",
    "@angular/platform-browser-dynamic": "^17.3.0",
    "@angular/platform-server": "^17.3.0",
    "@angular/router": "^17.3.0",
    "@angular/service-worker": "^17.3.0",
    "@angular/ssr": "^17.3.8",
    "@auth0/angular-jwt": "^5.2.0",
    "@types/crypto-js": "^4.2.2",
    "angular-google-tag-manager": "1.9.0",
    "bootstrap": "^5.3.3",
    "canvas-confetti": "^1.9.3",
    "crypto-js": "^4.2.0",
    "express": "^4.18.2",
    "glob-all": "^3.3.1",
    "ng2-pdf-viewer": "^10.4.0",
    "ngx-infinite-scroll": "^17.0.0",
    "ngx-owl-carousel-o": "^17.0.0",
    "purify-css": "^1.2.5",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.14.3"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^17.3.8",
    "@angular/cli": "^17.3.8",
    "@angular/compiler-cli": "^17.3.0",
    "@types/canvas-confetti": "^1.9.0",
    "@types/express": "^4.17.17",
    "@types/jasmine": "~5.1.0",
    "@types/node": "^18.19.0",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.4.2"
  }
}

